import BaseAPI from "../api";

const path: string = "/position";
export type listType = {
  position_name?: string;
  limit?: number;
  page?: number;
};
export type createType = {
  position_name: string
  status: string
  is_approve: boolean;
};

export class PositionApi extends BaseAPI {
  static list(query: listType): Promise<any> {
    return this.api.get(`${path}/list`, { params: { ...query } });
  }
  static id(id_position:number):Promise<any>{
    return this.api.get(`${path}/${id_position}`)
  }
  static create(form: createType): Promise<any> {
    return this.api.post(`${path}/create`, form);
  }
  static update(form: createType, id:number): Promise<any> {
    return this.api.patch(`${path}/${id}`, form);
  }
  static delete(id:number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
}
